import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class GAllData extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      visitid: "",
      DataLoaded: false,
      AntenatalLoaded: false,
      MedicalDisordersLoaded: false,
      ObstetricsDataLoaded: false,
      allModuleData: "",
      visible: "visible",
      // MLoaded: false,
    };

    this.PrintWindow = this.PrintWindow.bind(this);
  }
  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
      // 'visitid': localStorage.getItem('visitId')
    };
    axios
      .get(this.api_url+"alldata/get/allvalues", { headers: headers })
      .then((res) => {
        //   const verified = res.data;
        // console.log(res.data[0]['module'])
        // console.log(Object.keys(res.data['data']))
        var allModuleData = res.data["data"];
        console.log(allModuleData);
        let allstring = "";
        for (var i = 0; i < Object.keys(res.data["data"]).length; i++) {
          // console.log(Object.keys(res.data['data'])[i]+' '+typeof(res.data['data'][Object.keys(res.data['data'])[i]][0]))
          // console.log(res.data['data'][Object.keys(res.data['data'])[i]].length)

          var title =
            '<div className="col-lg-12"><h2>' +
            Object.keys(res.data["data"])[i] +
            " Data</h2></div>";

          if (
            typeof res.data["data"][Object.keys(res.data["data"])[i]][0] ==
            "object"
          ) {
            // console.log(title);
            // $('.allDataForm').append(title)

            allstring +=
              '<div className="row"><div className="table-responsive">';
            allstring += title;
            allstring += '<table className="table"><tr>';
            // console.log(Object.keys(res.data['data'][Object.keys(res.data['data'])[i]][0]))

            var object = res.data["data"][Object.keys(res.data["data"])[i]][0];
            var objectkeys = Object.keys(
              res.data["data"][Object.keys(res.data["data"])[i]][0]
            );
            // console.log((object));

            //table headers
            for (var j = 0; j < objectkeys.length; j++) {
              allstring += "<th>" + objectkeys[j] + "</th>";
            }
            allstring += "</tr>";
            for (
              var m = 0;
              m < res.data["data"][Object.keys(res.data["data"])[i]].length;
              m++
            ) {
              allstring += "<tr>";
              // console.log(m);
              let objectkeys = Object.keys(
                res.data["data"][Object.keys(res.data["data"])[i]][m]
              );
              // console.log((objectkeys));

              let object2 = Object.entries(
                res.data["data"][Object.keys(res.data["data"])[i]][m]
              );

              // console.log((object2[0][0]));
              //table rows
              for (var j = 0; j < object2.length; j++) {
                if (
                  object2[j][0] !== "_id" ||
                  object2[j][0] !== "chiefstatus" ||
                  object2[j][0] !== " modules" ||
                  object2[j][0] !== " staffuserid"
                ) {
                  // console.log(object2[j][1])
                  var div = "<td>" + object2[j][1] + "</td>";
                  // $('.allDataForm').append(div)
                  allstring += div;
                }
              }
              allstring += "</tr>";
            }

            allstring += "</table></div>";
            // for (var j = 0; j < objectkeys.length; j++) {
            //     if (objectkeys[j] !== '_id' || objectkeys[j] !== 'chiefstatus' || objectkeys[j] !== ' modules' || objectkeys[j] !== ' staffuserid') {
            //         // console.log(object[objectkeys[j]])
            //         var div = '<div className="py-1 col-lg-6 numberOfVisit1" ><h6 className="text-capitalize" style={fontFamilyNunito}>' + objectkeys[j] + '</h6><input className="form-control" readOnly value="' + object[objectkeys[j]] + '"  type="text" /></div>'
            //         // $('.allDataForm').append(div)
            //         allstring += div;
            //     }
            // }
            // allstring += '</div><br>'
            allstring += "</div><br>";
          }
        }
        //

        $("#appended").html(allstring);

        this.setState({
          allModuleData: Object.keys(res.data["data"]),
          visible: "visible",
        });
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { allModuleData, visible } = this.state;

    let { DataLoaded } = this.state;

    const menstrual_data = this.menstrual_data;

    return (
      <div>
        <Headers />
        <InterModularSidebar />

        <main className="content-container ">
          <div className="container p-2">
            <form>
              <div className="form-row pt-4 allDataForm">
                <div
                  className={visible}
                  style={{ width: "100%" }}
                  id="appended"
                ></div>
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <a className="btn btn-primary " onClick={this.PrintWindow}>
                  Download PDF
                </a>
                {/* {allModuleData.map(d => 
                    (<li >{d}</li>
                    ))}  */}
                {/* <MDBDataTable striped bordered data={menstrual_data} /><br/> */}

                {/* <h1  className="text-capitalize" style={font16}>Antenatal History</h1>
                 <MDBDataTable striped bordered data={antenatal_data} />
                <p className="text-capitalize" style={font16}>Obstetric History</p>
                 <MDBDataTable striped bordered data={obstetrichistory_data} />
                 <p className="text-capitalize" style={font16}>Pregnancy History</p>
                 <MDBDataTable striped bordered data={pregancyhistorydata} />
                 <p className="text-capitalize" style={font16}>Obstetric Ultra-sound</p>
                 <MDBDataTable striped bordered data={obsounddata} />
                 <p className="text-capitalize" style={font16}>Pre-plan Data</p>
                 <MDBDataTable striped bordered data={preplandata} />
                 <p className="text-capitalize" style={font16}>Complications Data</p>
                 <MDBDataTable striped bordered data={complicationdata} />
                 <p className="text-capitalize" style={font16}>Utilization Of Drugs Data</p>
                 <MDBDataTable striped bordered data={utilizationData} /> */}
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default GAllData;
